/* LLCL Mega Menu focus-exit contract v6.5
   Extends the existing V6.4 controller without changing open/navigation behavior.
*/
(() => {
  'use strict';

  const KEY = '__LLCL_MEGA_MENU_FOCUSOUT_V65__';
  if (window[KEY]) return;
  window[KEY] = true;

  const isDesktop = () => window.matchMedia('(min-width: 700px)').matches;

  document.addEventListener(
    'focusout',
    (event) => {
      if (!isDesktop()) return;

      const target = event.target instanceof Element ? event.target : null;
      const header = target?.closest('.ll-header--llcl');

      if (!header || !header.classList.contains('is-mega-open')) return;

      const next = event.relatedTarget;
      if (next instanceof Node && header.contains(next)) return;

      window.requestAnimationFrame(() => {
        const active = document.activeElement;
        if (active instanceof Node && header.contains(active)) return;

        window.__LLCL_MEGA_MENU_V64__?.closeAll?.();
      });
    },
    true
  );
})();
